import { render } from "./PaymentComponent.vue?vue&type=template&id=1f3985d2"
import script from "./PaymentComponent.vue?vue&type=script&lang=js"
export * from "./PaymentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/checkout/payment/PaymentComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f3985d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f3985d2', __exports__)) {
    api.reload('1f3985d2', __exports__)
  }
  
  module.hot.accept("./PaymentComponent.vue?vue&type=template&id=1f3985d2", () => {
    api.rerender('1f3985d2', render)
  })

}


export default __exports__